import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-right-transparent",
  "use": "arrow-right-transparent-usage",
  "viewBox": "0 0 30 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 36\" id=\"arrow-right-transparent\">\n    <path fill=\"none\" fill-rule=\"evenodd\" stroke=\"#FFF\" d=\"M2.142 20.034a2.5 2.5 0 0 1 0-4.192L25.075.932a2.5 2.5 0 0 1 3.863 2.097v29.817a2.5 2.5 0 0 1-3.863 2.096L2.142 20.034z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol